// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.\
import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import GlobalComponents from './components/GlobalComponents'
import './assets/scss/style.scss'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'
import VueAMap from 'vue-amap'
import min from './assets/js/min'
import axios from 'axios'
import './assets/ico/iconfont.css'
//import VueAxios from 'vue-axios'
import x2js from 'x2js'
import VDistpicker from 'v-distpicker'
import cssVars from 'css-vars-ponyfill'
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css'; 
Vue.use(VueAreaLinkage);
cssVars({})
// 地址组件
Vue.component('v-distpicker', VDistpicker)
// xml格式转换
Vue.prototype.$x2js = new x2js()
// axios请求地址
//axios.defaults.baseURL='http://182.254.196.172:8088/WebInterface/'
Vue.prototype.$axios = axios
//axios.defaults.baseURL="http://182.254.196.172:8026",
//axios.defaults.baseURL = '/api',
//axios.defaults.baseURL='http://192.168.1.30:8026',

//Vue.use(VueAxios,axios);
// 正则验证
Vue.use(min)
Vue.use(vueSwiper)
// ui组件
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(GlobalComponents)
// 定位地图组件
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    //修改下面的key值
    key: 'cc9b897b3fbecbb341b56a1c6bbec772',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch',
        'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
        'AMap.PolyEditor', 'AMap.CircleEditor'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router, store,
    store: store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js